import React, { useCallback, useContext, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ShawerIcon from '../../../assets/img/svg/shawer-icon.svg'
import BadIcon from '../../../assets/img/svg/bad-icon.svg'
import { defaultUserImg } from '../../../helper/imagepath'
import { useNavigate } from 'react-router-dom'
import {
  checkIfPastDate,
  convertTimestampToDate,
  convertTimestampToTime,
  getBookingStatusClass,
  getUserRole,
  hasAccess
} from '../../../helper/function'
import { getSchedulePropertyDataById } from '../../../redux/slices/propertySlice'
import { SpinnerContext } from '../../../context/spinnerContext'
import Pagination from '../../../component/common/pagination'
import StatusModal from '../../../component/modal/statusModal'
import CancelModalContent from '../../../component/scheduleStatus/canceleModalContent'
import ScheduledModalContent from '../../../component/scheduleStatus/scheduledModalContent'

const UpcomimngCleaning = ({ allUpcomingCleaning, currentPage, setCurrentPage, page, setUpcomingRefresh }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { scheduledProperties } = useSelector((state) => state.property)
  // eslint-disable-next-line no-unused-vars
  const [itemsPerPage, setItemsPerPage] = useState(allUpcomingCleaning?.currentRecords || 10)
  const [viewDetail, setViewDetail] = useState(null)
  const [chatUserId, setChatUserId] = useState(null)
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false)
  const [modalName, setModalName] = useState(null)

  const clientName = useMemo(
    () =>
      scheduledProperties?.getPropertyScheduleData?.properties?.client?.first_name
        ? scheduledProperties?.getPropertyScheduleData?.properties?.client?.first_name +
          ' ' +
          scheduledProperties?.getPropertyScheduleData?.properties?.client?.last_name
        : '',
    [scheduledProperties?.getPropertyScheduleData?.properties]
  )

  const overFun = useMemo(() => {
    return viewDetail?.next_checkin_time
      ? checkIfPastDate(viewDetail?.next_checkin_time, false)
      : checkIfPastDate(viewDetail?.booking_date_time, true)
  }, [viewDetail?.booking_date_time, viewDetail?.next_checkin_time])

  const onHandleDetails = useCallback(
    (data) => {
      setViewDetail(data)
      const { booking_status, property_schedule_id } = data
      setChatUserId(property_schedule_id)
      if (['scheduled', 'canceled', 'in progress', 'canceled cleaner']?.includes(booking_status)) {
        getPropertyData(property_schedule_id, booking_status)
      } else if (['completed']?.includes(booking_status)) {
        navigate(`/${page}/complete-cleaning/${property_schedule_id}/cleaningDetail`)
      }
    },
    [navigate]
  )

  const getPropertyData = async (schedule_id, status) => {
    changeLoader(true)
    await dispatch(getSchedulePropertyDataById(schedule_id))
      .then(() => {
        setIsStatusModalOpen(true)
        setModalName(status)
        changeLoader(false)
      })
      .catch(() => {
        changeLoader(false)
      })
  }

  // Handle page change, adjusting for 1-based index
  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected + 1) // Add 1 to the index to start from 1
    setUpcomingRefresh(true)
  }

  return (
    <div className="mb-4">
      <div className="common_heading_div">
        <h4>Upcoming Cleanings</h4>
      </div>
      <div className="row">
        {allUpcomingCleaning?.upcomingSchedules?.length > 0 ? (
          allUpcomingCleaning?.upcomingSchedules?.map((upcomingCleaning, index) => (
            <div className="col-md-12 col-lg-6 col-xl-6" key={index}>
              <div className="common_card_div upcoming_cleanings_space_div">
                <div className="upcoming_cleanings_box_div">
                  <div className="upcoming_cleanings_inner_box upcoming_cleanings_flex_div mb-2">
                    <div className="user_img_div">
                      <div className="cleanings_img_div">
                        <img className="img-fluid" src={defaultUserImg} alt="Image" />
                      </div>
                      <div className="user_right_contains">
                        <h6 className="mb-0">
                          {upcomingCleaning?.cleaners
                            ? `${upcomingCleaning?.cleaners?.first_name || ''} ${upcomingCleaning?.cleaners?.last_name || ''}`
                            : 'No Cleaner Yet'}
                        </h6>
                        <div>
                          <span
                            className={
                              upcomingCleaning?.scheduleCleaners
                                ? upcomingCleaning?.scheduleCleaners?.is_accepted
                                  ? 'accepted_text'
                                  : 'declined_text'
                                : 'pennding_text'
                            }
                          >
                            {upcomingCleaning?.scheduleCleaners
                              ? upcomingCleaning?.scheduleCleaners?.is_accepted
                                ? 'Accepted'
                                : 'Declined'
                              : 'Pending'}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="show_box show_bg" onClick={() => onHandleDetails(upcomingCleaning)}>
                      <p>Details</p>
                    </div>
                  </div>
                  <div className="upcoming_cleanings_flex_div mb-2">
                    <p className="fs-14 gray_color fw-400">
                      {upcomingCleaning?.properties?.address} - {upcomingCleaning?.properties?.city}
                    </p>
                    <div className={`show_box ${getBookingStatusClass(upcomingCleaning?.booking_status)}`}>
                      <p>{upcomingCleaning?.booking_status}</p>
                    </div>
                  </div>
                  <div className="upcoming_cleanings_flex_div mb-2">
                    <div className="amount_div">
                      {hasAccess('accessFinalAmount', getUserRole()) && (
                        <p className="fs-14 black_color fw-400 me-3">${upcomingCleaning?.finalAmount}</p>
                      )}
                      <label className="cleanings_icon_box_div">
                        <img className="img-fluid" src={ShawerIcon} alt="Image" />
                        {upcomingCleaning?.properties?.number_of_bathroom}
                      </label>
                      <label className="cleanings_icon_box_div">
                        <img className="img-fluid" src={BadIcon} alt="Image" />
                        {upcomingCleaning?.properties?.number_of_rooms}
                      </label>
                    </div>
                    {/* <div className="show_box gray_bg">
                      <p>Paid</p>
                    </div> */}
                  </div>
                  <div className="upcoming_cleanings_flex_div">
                    <p className="fs-14 dark_blue_color fw-400">
                      <span>{convertTimestampToDate(upcomingCleaning?.booking_date_time)}</span> |{' '}
                      <span>{convertTimestampToTime(upcomingCleaning?.booking_date_time)}</span>
                    </p>
                    <div className="">
                      <p className="fs-16 black_color fw-500">#{upcomingCleaning?.schedule_number}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <h4 className="not_found text-center">No Data Found</h4>
        )}
      </div>
      {allUpcomingCleaning?.total > 0 && (
        <Pagination
          currentPage={currentPage}
          onPageChange={handlePageChange}
          totalPages={allUpcomingCleaning?.totalPages || 0}
          itemsPerPage={itemsPerPage}
        />
      )}

      {/* Modal open */}
      {isStatusModalOpen && (
        <StatusModal
          onClose={() => setIsStatusModalOpen(false)}
          title={`Cleaning #${scheduledProperties?.getPropertyScheduleData?.schedule_number}`}
          headerContent={{
            name: clientName,
            status: scheduledProperties?.getPropertyScheduleData?.booking_status
          }}
          chatUserId={chatUserId}
          CheckTimeOver={overFun}
          clientId={scheduledProperties?.getPropertyScheduleData?.properties?.client?.client_id}
        >
          {['canceled', 'canceled cleaner']?.includes(modalName) && (
            <CancelModalContent
              data={scheduledProperties?.getPropertyScheduleData}
              finalAmount={scheduledProperties?.finalAmount}
              onClose={() => setIsStatusModalOpen(false)}
            />
          )}
          {['scheduled', 'in progress']?.includes(modalName) && (
            <ScheduledModalContent
              data={scheduledProperties?.getPropertyScheduleData}
              onClose={() => setIsStatusModalOpen(false)}
              page={page}
              setIsRefresh={setUpcomingRefresh}
            />
          )}
        </StatusModal>
      )}
    </div>
  )
}

export default UpcomimngCleaning
